import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import React__default, { useState } from 'react';
import { c as clsx } from '../clsx.m-7e9a4a81.js';
import { I as Input } from '../Input-b87b9e0c.js';
import { P as Popper } from '../Popper-d2ca71bf.js';
import '@babel/runtime-corejs3/helpers/typeof';
import '@babel/runtime-corejs3/core-js-stable/array/is-array';
import '@babel/runtime-corejs3/core-js-stable/object/keys';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import '@babel/runtime-corejs3/core-js-stable/instance/filter';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import '@babel/runtime-corejs3/core-js-stable/object/define-property';
import '@babel/runtime-corejs3/helpers/defineProperty';
import '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import '@babel/runtime-corejs3/helpers/extends';
import '@babel/runtime-corejs3/helpers/toConsumableArray';
import '@babel/runtime-corejs3/core-js-stable/instance/concat';
import '@babel/runtime-corejs3/core-js-stable/instance/includes';
import '@babel/runtime-corejs3/core-js-stable/map';
import '@babel/runtime-corejs3/core-js-stable/set';
import '@babel/runtime-corejs3/core-js-stable/instance/entries';
import '@babel/runtime-corejs3/core-js-stable/instance/flags';
import '@babel/runtime-corejs3/core-js-stable/instance/reduce';
import '@babel/runtime-corejs3/core-js-stable/instance/some';
import '@babel/runtime-corejs3/core-js-stable/object/assign';
import '@babel/runtime-corejs3/core-js-stable/instance/find';
import '@babel/runtime-corejs3/core-js-stable/parse-float';
import '@babel/runtime-corejs3/core-js-stable/promise';
import '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import '@babel/runtime-corejs3/core-js-stable/instance/every';
import '@babel/runtime-corejs3/core-js-stable/instance/slice';
import '@babel/runtime-corejs3/core-js-stable/instance/sort';
import 'react-transition-group';
import '@thimble/utility';

var offset = Popper.modifiers.createOffsetModifier(0, 10);

var Select = function Select(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      options = _ref.options,
      renderOptions = _ref.renderOptions;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      pendingIndex = _useState4[0],
      setPendingIndex = _useState4[1];

  var select = function select(index) {
    onChange === null || onChange === void 0 ? void 0 : onChange(options[index].value);
    setVisible(false);
  };

  var handleKeyDown = function handleKeyDown(e) {
    switch (e.key) {
      case 'Enter':
        e.preventDefault();

        if (pendingIndex > -1 && pendingIndex < options.length) {
          select(pendingIndex);
        }

        break;

      case 'ArrowDown':
        e.preventDefault();

        if (options.length) {
          setVisible(true);
          setPendingIndex((pendingIndex + 1) % options.length);
        }

        break;

      case 'ArrowUp':
        e.preventDefault();

        if (options.length) {
          setVisible(true);
          setPendingIndex((pendingIndex - 1 + options.length) % options.length);
        }

        break;

      case 'Escape':
        e.preventDefault();
        setVisible(false);
        break;
    }
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Popper, {
    visible: visible,
    popup: /*#__PURE__*/React__default.createElement("div", null, _mapInstanceProperty(options).call(options, function (item, index) {
      var iValue = item.value,
          label = item.label;
      return /*#__PURE__*/React__default.createElement("div", {
        key: "".concat(iValue),
        className: clsx('smb-option', pendingIndex === index && 'smb-option--pending', value === iValue && 'smb-option--selected'),
        onMouseMove: function onMouseMove() {
          return setPendingIndex(index);
        },
        onTouchMove: function onTouchMove() {
          return setPendingIndex(index);
        },
        onClick: function onClick() {
          return select(index);
        }
      }, renderOptions ? renderOptions(item) : /*#__PURE__*/React__default.createElement("div", {
        className: "smb-option__inner"
      }, label || iValue));
    })),
    modifiers: [Popper.modifiers.sameWidth, offset],
    popupClassName: "smb-popper--tooltip smb-popper--zoom-y",
    onClose: function onClose() {
      return setVisible(false);
    }
  }, /*#__PURE__*/React__default.createElement(Input, {
    readOnly: true,
    onClick: function onClick() {
      return setVisible(true);
    },
    onKeyDown: handleKeyDown,
    value: (value === null || value === void 0 ? void 0 : value.toString()) || ''
  })));
};

export default Select;
